import React, { Component } from 'react';
import './style.scss';
import {
    Button, Col, Row, Card, CardBody, Form, FormGroup
} from 'reactstrap';
import fileSaver from 'file-saver';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Preloading } from '../../../components/UI/Preloader/action';
import { uploadXbrlMasterTemplate, downloadXbrlMasterTemplate, fetchXbrlMappingStatistics } from '../action';
class XBRLMasterKeys extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        this.props.fetchXbrlMappingStatistics()
    }
    componentDidUpdate(prevProps) {
        const { mappingStatisticsFailure, downloadTemplate, downloadTemplateFailure, uploadTemplate, uploadTemplateFailure } = this.props
        if (mappingStatisticsFailure !== prevProps.mappingStatisticsFailure) {
            toast.error(
                <div>
                    {mappingStatisticsFailure.data.message}
                </div>
            );
        }
        if (downloadTemplate !== prevProps.downloadTemplate) {
            this.props.preloading(false)
            var blob = new Blob([downloadTemplate], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
            fileSaver.saveAs(blob, 'XBRL_MASTER_KEY_TEMPLATE.xlsx');
        }
        if (downloadTemplateFailure !== prevProps.downloadTemplateFailure) {
            this.props.preloading(false)
            toast.error(
                <div>
                    {downloadTemplateFailure.data.message}
                </div>
            );
        }
        if (uploadTemplate !== prevProps.uploadTemplate) {
            this.props.preloading(false)
            toast.success(
                <div>
                    XBRL master data template uploaded successfully
                </div>
            );
            document.getElementById('file').value = ''
        }
        if (uploadTemplateFailure !== prevProps.uploadTemplateFailure) {
            this.props.preloading(false)
            toast.error(
                <div>
                    {uploadTemplateFailure.data.message}
                </div>
            );
        }
    }
    downloadExcel = (event) => {
        event.preventDefault();
        this.props.preloading(true)
        this.props.downloadXbrlMasterTemplate()
    }

    uploadExcel = (event) => {
        event.preventDefault();
        this.props.preloading(true);
        this.props.uploadXbrlMasterTemplate(event.target.files[0])
    }
    render() {
        return (
            <Col>
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">Edit XBRL Master Data Keys</h4>
                        </div>
                        <Card>
                            <CardBody>
                                <Form className="w-70">
                                    <FormGroup className="position-relative">
                                        <Row>
                                            <Col xs="20">
                                                <Button color="primary" onClick={this.downloadExcel}><i className="fa fa-download"></i>&nbsp;Download XBRL Template </Button>
                                                <div color="primary" className="btn btn-primary ml-3 position-relative" >
                                                    {/* <div> */}
                                                    <input onChange={this.uploadExcel} type="file" name="file" id="file" className="upload-file" title="Upload New Risk Factor" />
                                                    <i className="fa fa-upload"></i>&nbsp;Upload XBRL Template
                                                    {/* </div> */}
                                                </div>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Form>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                <table className="table table-bordered border-bottom-0 case-about-table">
                                    <tbody>
                                        <tr>
                                            <th className="header-blue" width="30%">Unmapped XBRL Keys</th>
                                            <td className="text-truncate"> {this.props.mappingStatistics.unmappedXbrlKeys}</td>
                                        </tr>
                                        <tr>
                                            <th width="30%" className="header-blue">Unmapped XbrlKeys With Year Contexts</th>
                                            <td className="text-truncate"> {this.props.mappingStatistics.unmappedXbrlKeysWithYearContexts}</td>
                                        </tr>
                                        <tr>
                                            <th width="30%" className="header-blue">Mapped Xbrl Keys</th>
                                            <td className="text-truncate"> {this.props.mappingStatistics.mappedXbrlKeys}</td>
                                        </tr>
                                        <tr>
                                            <th width="30%" className="header-blue">Mapped Xbrl Keys With Year Contexts</th>
                                            <td> {this.props.mappingStatistics.mappedXbrlKeysWithYearContexts} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Col>
        );
    }
}
const mapStateToProps = (state) => ({
    downloadTemplate: state.globalConfiguration.xbrlDownloadTemplateSuccess,
    downloadTemplateFailure: state.globalConfiguration.xbrlDownloadTemplateFailure,
    uploadTemplate: state.globalConfiguration.uploadXbrlTemplate,
    uploadTemplateFailure: state.globalConfiguration.uploadXbrlTemplateFailure,
    mappingStatistics: state.globalConfiguration.mappingStatistics,
    mappingStatisticsFailure: state.globalConfiguration.mappingStatisticsFailure
});

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    downloadXbrlMasterTemplate: () => { dispatch(downloadXbrlMasterTemplate()) },
    uploadXbrlMasterTemplate: (data) => { dispatch(uploadXbrlMasterTemplate(data)) },
    fetchXbrlMappingStatistics: () => { dispatch(fetchXbrlMappingStatistics()) }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(XBRLMasterKeys);
